import React from "react";
import { connect } from "react-redux";
import Token from "api/Auth/auth";
import { setMgToken, setHcToken } from "store/Auth";
import store from "store.js";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import shareto from "views/job-details/img/upload.png";
import referingbanner from "views/job-details/img/referingbanner.png";
import pin from "views/job-details/img/pin.svg";
import checksuccess from "views/job-details/img/checksuccess.png";
class ReferFriendPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSuccess: false };
    // console.log(props.showRefer);
  }
  render() {
    return (
      <>
        <Modal
          center
          open={this.props.showRefer}
          onClose={this.props.onclose}
          classNames={{
            modal: "refermodal-w",
          }}
        >
          <div className="refer-modal lg:p-4 md:p-4 ">
            {!this.state.isSuccess && (
              <div>
                <div>
                  <h2 className="refer-h2 uppercase sm-fsize16">
                    Help your friend get a career at ICICI
                  </h2>
                </div>

                <div className="lg:flex md:flex sm-colum-reverse">
                  <form action="" className="lg:w-1/2 md:w-1/2 w-full m-auto">
                    <div className="">
                      <div class="form-group modal-form-cs">
                        <label for="">Name</label>
                        <input type="text" placeholder="" value="Full Name" />
                      </div>
                      <div class="form-group pt-4 modal-form-cs">
                        <label for="">Mobile Number</label>
                        <input type="text" placeholder="" value="9867654327" />
                      </div>

                      <div class="form-group pt-4 modal-form-cs">
                        <label for="">Email</label>
                        <input
                          type="text"
                          placeholder=""
                          value="info@gmail.com"
                        />
                      </div>

                      <div class="form-group mt-8 modal-form-cs w-full h-90px justify-center items-center flex  bord-radius">
                        <div>
                          <img src={shareto} className="m-auto" />
                          <p className="fsize16 text-black pt-2">
                            Upload Resume
                          </p>
                        </div>
                      </div>

                      <div class="w-full fixed-btn mt-6">
                        <a
                          class="btn btn-orange-otp btn-otp mx-auto myBtn"
                          onClick={() =>
                            this.setState({
                              isSuccess: !this.state.isSuccess,
                            })
                          }
                          href="#"
                        >
                          REFER FRIEND
                        </a>
                      </div>
                    </div>
                  </form>

                  <div className="lg:w-1/2 md:w-1/2 w-full lg:pl-8 md:pl-8 lg:mb-0 mb-4 sm-px10px">
                    <p className="fsize14 mb-3">Referring Job</p>

                    <card className="rounded-12px drop-shadow block">
                      <img src={referingbanner} />
                      <div className="p-6">
                        <h1 className="fsize18 font-bold">
                          Phone Banking Officer
                        </h1>

                        <div>
                          <p className="fsize12 color-lgrey mt-2">
                            Required Experience:
                            <span className="text-black  font-bold">
                              {" "}
                              1-3 years
                            </span>
                          </p>
                          <p className="fsize12 color-lgrey mt-1">
                            Education:
                            <span className="text-black  font-bold"> CA</span>
                          </p>
                        </div>
                        <p className="dashed-border-b mt-4"></p>

                        <div className="flex justify-start items-center mt-4">
                          <div className="flex items-center">
                            <img src={pin} className="pn-icon-w" />

                            <p className="text-muted-400 ml-2">Mumbai</p>
                          </div>
                          <span className="dot-point bg-bluecolor rounded-full mx-4 "></span>
                          <p className="text-muted-400">3d ago</p>
                        </div>
                        <p className="underline fsize14 text-orange-c mt-6">
                          View Details
                        </p>
                      </div>
                    </card>
                  </div>
                </div>
              </div>
            )}
            {this.state.isSuccess && (
              <div>
                <img src={checksuccess} className="m-auto" />
                <h1 className="fsize18 text-center font-bold line-h25 mt-4">
                  Referral Success
                </h1>
                <div class="w-full fixed-btn lg:mt-16 md:mt-16 mt-6">
                  <a
                    class="btn btn-orange-otp btn-otp-wauto mx-auto myBtn"
                    href="#"
                  >
                    REFER ANOTHER FRIEND
                  </a>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </>
    );
  }
}

export default ReferFriendPopup;
